import api from "./api";

const PREFIX = "api/jobs";

export const jobService = {
  listImportJobs: async (body) => {
    const response = await api.post(`${PREFIX}/import/list`, body);
    return response.data;
  },

  listExportJobs: async (body) => {
    const response = await api.post(`${PREFIX}/export/list`, body);
    return response.data;
  },

  getJobStatus: async (body) => {
    const response = await api.post(`${PREFIX}/status`, body);
    return response.data;
  },

  /** Request cancellation of a running/queued import or export job. */
  cancelJob: async (body) => {
    const response = await api.post(`${PREFIX}/cancel`, body);
    return response.data;
  },

  startImport: async (projectId, file, columnMapping = {}) => {
    const formData = new FormData();
    formData.append("project_id", projectId);
    if (file) formData.append("file", file);
    formData.append("column_mapping", JSON.stringify(columnMapping || {}));
    const response = await api.post(`${PREFIX}/import/start`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  },

  startExport: async (body) => {
    const response = await api.post(`${PREFIX}/export/start`, body);
    return response.data;
  },

  getDownloadUrl: async (body) => {
    const response = await api.post(`${PREFIX}/download-url`, body);
    return response.data;
  },

  /** Download sample Excel template for import. Pass project_id for project-specific columns (Suite, Steps format). */
  getImportSample: async (body = {}) => {
    const response = await api.post(`${PREFIX}/import/sample`, body, {
      responseType: "blob",
    });
    return response.data;
  },
};

export default jobService;
